var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00033 17.3327C4.39795 17.3327 0.666992 13.6017 0.666992 8.99935C0.666992 4.39697 4.39795 0.666016 9.00033 0.666016C13.6027 0.666016 17.3337 4.39697 17.3337 8.99935C17.3337 13.6017 13.6027 17.3327 9.00033 17.3327ZM9.00033 15.666C12.6822 15.666 15.667 12.6813 15.667 8.99935C15.667 5.31745 12.6822 2.33268 9.00033 2.33268C5.31843 2.33268 2.33366 5.31745 2.33366 8.99935C2.33366 12.6813 5.31843 15.666 9.00033 15.666ZM8.16916 12.3327L4.63365 8.79718L5.81217 7.6186L8.16916 9.97568L12.8832 5.26162L14.0617 6.44012L8.16916 12.3327Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedIcon);
export default __webpack_public_path__ + "static/media/selectedIcon.20aab5af61883d725ea9480bb104ffde.svg";
export { ForwardRef as ReactComponent };